export const types = {
  gte: 'gte',
  lte: 'lte',
}

export const optionTypes = [
  { value: types.gte, label: 'o más' },
  { value: types.lte, label: 'o menos' },
]
